import { getDefaultRichTextElements } from './Localization';

let messages: Record<string, string> = {};

let currentLang = 'en';

const DEFAULT_TAGS = {
  ...getDefaultRichTextElements(),
  strong: (chunks: string) => <strong>{chunks}</strong>,
  p: (chunks: string) => <p>{chunks}</p>,
  br: () => <br />,
};

let customTags = { ...DEFAULT_TAGS };

export const setCurrentLang = (lang: string) => (currentLang = lang);
export const getCurrentLang = () => currentLang;
export const setCustomTags = (tags: object) => {
  customTags = { ...DEFAULT_TAGS, ...tags };
};
export const getCustomTags = () => customTags;

// as we compile our locales to AST, we need to temporary support it,
// so added small hack to always read value
export const setMessages = (newMessages: Record<string, string>) => {
  if (
    Object.entries(newMessages).some(([, value]) => typeof value === 'object')
  ) {
    messages = Object.entries(newMessages).reduce(
      (acc, [key, value]) => {
        if (typeof value === 'string') {
          acc[key] = value;
        } else if (Array.isArray(value)) {
          acc[key] = (value[0] as any)?.value;
        } else {
          acc[key] = (value as any)?.value || value;
        }

        return acc;
      },
      {} as { [key: string]: string }
    );
  } else {
    messages = newMessages;
  }
};
export const getMessages = () => messages;
